<template>
  <div class="page">
    <div class="page__bd">

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd form-detail-preview" v-if="form.product">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料名称</label>
            <span class="weui-form-preview__value">{{form.product.pr_detail}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料编号</label>
            <span class="weui-form-preview__value">{{form.product.pr_code}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.product.pr_orispeccode">
            <label class="weui-form-preview__label">型号</label>
            <span class="weui-form-preview__value">{{form.product.pr_orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.product.pr_spec">
            <label class="weui-form-preview__label">规格</label>
            <span class="weui-form-preview__value">{{form.product.pr_spec}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">厂家/品牌</label>
            <span class="weui-form-preview__value">{{form.product.pr_brand}}</span>
          </div>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd form-detail-preview" v-for="(item,index) in form.stockList" :key="item.pw_whcode">
          <div class="form-detail-preview_num">{{index + 1}}</div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">仓库</label>
            <span class="weui-form-preview__value">{{item.pw_whname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">数量</label>
            <span class="weui-form-preview__value">{{item.pw_onhand}} {{form.product.pr_unit}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.pw_lockqty">
            <label class="weui-form-preview__label">锁定数量</label>
            <span class="weui-form-preview__value">{{item.pw_lockqty}} {{form.product.pr_unit}}</span>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import form from "@/mixins/form.js";

export default {
  mixins: [form],
  data() {
    return {
      baseUrl: "/api/storage/product/wh_stock",
    };
  },
  methods: {
  /* 
    重写，$loading的url和params
  */
    f_get(callback, id) {
      var me = this;
      id = id || me.initId || me.$route.params.id || me.$route.query.id;
      if (id) {
          me.$loading({
              url: me.baseUrl,
              params: {
                id,
              }
          }).then(function (res) {
              if (res.success) {
                  me.form = res.data;
                  if (callback && typeof callback === 'function') {
                      callback.call(me, res.data);
                  }
                  if (me.f_afterload && typeof me.f_afterload === 'function') {
                      me.f_afterload.call(me, res.data);
                  }
              } else {
                  me.$router.push({
                      name: "Error",
                      params: res
                  });
              }
          });
      } else if (me.initData) {
          me.form = me.initData;
      }
    },
  }
};
</script>